@if (legacyService?.getLegacyMode() === true) {
  <div class="emperor-ui-chip" [ngClass]="colorClass">
    <ng-container *ngTemplateOutlet="contentTemp"></ng-container>
  </div>
} @else {
  <mat-chip>
    <ng-container *ngTemplateOutlet="contentTemp"></ng-container>
  </mat-chip>
}

<ng-template #contentTemp>
  <ng-content></ng-content>
</ng-template>
